import { Link } from "react-router-dom";
import { allCategories, getNewsByCategory } from "@/utils/news";

const iconMap: Record<string, string> = {
  society: "ri-group-line",
  politics: "ri-government-line",
  economy: "ri-line-chart-line",
  breaking: "ri-flashlight-line",
  exclusive: "ri-eye-2-line",
};

export default function CategoryGrid() {
  return (
    <section className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-16">
      <div className="mb-8 flex items-end justify-between">
        <div>
          <span className="font-label text-xs tracking-[0.3em] text-primary-700">
            SECTIONS
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            按分类浏览爆料
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {allCategories.map((category) => (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-500"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-200 text-xl text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-foreground-950">
              <i className={iconMap[category.slug] ?? "ri-article-line"} />
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
              {category.name}
            </h3>
            <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
              {category.description}
            </p>
            <span className="mt-4 flex items-center gap-1 text-xs text-accent-400">
              {getNewsByCategory(category.slug).length} 条爆料
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}